import { jsPDF } from 'jspdf';
import {
  drinkItems, deliveryItems, eventTypes, partners,
  structureItems, STRUCTURE_FEE_PER_PERSON, ALMOCO_JANTAR,
} from '../data/mockData';

const COLORS = {
  bronze: [139, 111, 71],
  champagne: [201, 169, 97],
  lightChamp: [212, 180, 131],
  ivory: [245, 237, 221],
  black: [15, 13, 10],
  textDark: [40, 32, 22],
  textMuted: [120, 110, 95],
  border: [200, 190, 170],
  softBg: [252, 248, 240],
};

const fmtBRL = (n) => `R$ ${Number(n || 0).toLocaleString('pt-BR')}`;
const fmtBRL2 = (n) => `R$ ${Number(n || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const formatDateBR = (iso) => {
  if (!iso) return 'A definir';
  const [y, m, d] = String(iso).split('-');
  if (!y || !m || !d) return iso;
  return `${d}/${m}/${y}`;
};

export const generateBudgetPdf = ({
  leadName, leadWhatsapp,
  serviceType, eventType, guests, eventDate, eventLocation,
  selectedPackage, activeItems, substitutePratoQuente,
  selectedDrinks, selectedPartners, deliveryQuantities,
  totalPrice,
}) => {
  const doc = new jsPDF({ unit: 'mm', format: 'a4' });
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();

  const pageFooter = () => {
    doc.setFillColor(...COLORS.champagne);
    doc.rect(0, H - 12, W, 0.6, 'F');
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.setTextColor(...COLORS.bronze);
    doc.text('Buffet MultiEventos', 15, H - 6);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.setTextColor(...COLORS.textMuted);
    doc.text('WhatsApp (31) 99917-2997', W - 15, H - 6, { align: 'right' });
  };
  const newPage = () => { pageFooter(); doc.addPage(); return 25; };
  const ensure = (y, needed) => (y + needed > H - 20 ? newPage() : y);

  /* ===== HEADER ===== */
  let y = 0;
  doc.setFillColor(...COLORS.black);
  doc.rect(0, 0, W, 38, 'F');
  doc.setFillColor(...COLORS.champagne);
  doc.rect(0, 38, W, 0.8, 'F');

  doc.setFont('times', 'bold');
  doc.setFontSize(22);
  doc.setTextColor(...COLORS.ivory);
  doc.text('Buffet', 15, 22);
  doc.setTextColor(...COLORS.champagne);
  doc.text('MultiEventos', 15 + doc.getTextWidth('Buffet '), 22);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);
  doc.setTextColor(180, 170, 150);
  doc.text('+ 30 ANOS  •  EVENTOS  •  BUFFET  •  DRINKS', 15, 30);

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.setTextColor(...COLORS.champagne);
  doc.text('ORÇAMENTO PERSONALIZADO', W - 15, 20, { align: 'right' });
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);
  doc.setTextColor(180, 170, 150);
  doc.text(`Gerado em ${new Date().toLocaleDateString('pt-BR')}`, W - 15, 27, { align: 'right' });

  y = 50;

  /* ===== CLIENT ===== */
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(7);
  doc.setTextColor(...COLORS.bronze);
  doc.text('CLIENTE', 15, y); y += 6;
  doc.setFont('times', 'bold');
  doc.setFontSize(16);
  doc.setTextColor(...COLORS.textDark);
  doc.text(leadName || '—', 15, y);
  if (leadWhatsapp) {
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(...COLORS.textMuted);
    doc.text(`WhatsApp: ${leadWhatsapp}`, 15, y + 6);
  }
  y += 14;

  /* ===== EVENT DETAILS ===== */
  doc.setDrawColor(...COLORS.border);
  doc.setFillColor(...COLORS.softBg);
  doc.roundedRect(15, y, W - 30, 28, 2, 2, 'FD');

  const eventLabel = serviceType === 'delivery'
    ? 'Encomenda (Delivery)'
    : (eventTypes.find(e => e.id === eventType)?.label || '—');

  const cols = serviceType === 'delivery'
    ? [
        ['TIPO', 'Delivery'],
        ['ITENS', `${Object.values(deliveryQuantities || {}).reduce((a, b) => a + (b || 0), 0)} un`],
      ]
    : [
        ['EVENTO', eventLabel],
        ['CONVIDADOS', String(guests || '—')],
        ['DATA', formatDateBR(eventDate)],
        ['LOCAL', eventLocation || 'A definir'],
      ];
  const colCount = cols.length;
  const colW = (W - 30) / colCount;
  cols.forEach(([label, value], i) => {
    const x = 15 + i * colW + 6;
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(7);
    doc.setTextColor(...COLORS.bronze);
    doc.text(label, x, y + 8);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(...COLORS.textDark);
    const text = doc.splitTextToSize(String(value), colW - 12);
    doc.text(text, x, y + 16);
  });
  y += 38;

  /* ===== PACKAGE / ITEMS ===== */
  const drawSectionTitle = (title) => {
    y = ensure(y, 10);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.setTextColor(...COLORS.bronze);
    doc.text(title, 15, y);
    doc.setDrawColor(...COLORS.champagne);
    doc.setLineWidth(0.4);
    doc.line(15, y + 1.5, W - 15, y + 1.5);
    y += 7;
  };

  const drawLine = (label, sub, value) => {
    y = ensure(y, sub ? 10 : 8);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(...COLORS.textDark);
    doc.text(label, 17, y);
    if (sub) {
      doc.setFontSize(8);
      doc.setTextColor(...COLORS.textMuted);
      doc.text(sub, 17, y + 4.5);
    }
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    doc.setTextColor(...COLORS.bronze);
    doc.text(value, W - 17, y, { align: 'right' });
    y += sub ? 9 : 7;
  };

  if (serviceType === 'presencial' && selectedPackage) {
    drawSectionTitle(`PACOTE — ${selectedPackage.name.toUpperCase()}`);
    drawLine(selectedPackage.name,
      `${guests} × ${fmtBRL2(selectedPackage.pricePerPerson)} por pessoa`,
      fmtBRL(Math.round(selectedPackage.pricePerPerson * guests)));

    /* Itens inclusos no pacote (lista) */
    if ((activeItems || []).length > 0) {
      y = ensure(y, 8);
      y += 2;
      doc.setFont('helvetica', 'italic');
      doc.setFontSize(8);
      doc.setTextColor(...COLORS.textMuted);
      doc.text('Inclusos no pacote:', 17, y);
      y += 4.5;
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9);
      doc.setTextColor(...COLORS.textDark);
      (activeItems || []).forEach((it) => {
        y = ensure(y, 5.2);
        doc.setTextColor(...COLORS.champagne);
        doc.text('•', 19, y);
        doc.setTextColor(...COLORS.textDark);
        const line = it.desc ? `${it.label} — ${it.desc}` : it.label;
        const wrapped = doc.splitTextToSize(line, W - 60);
        doc.text(wrapped, 23, y);
        y += wrapped.length * 4.5;
      });
      y += 2;
    }

    /* Substituição Prato Quente -> Almoço/Jantar */
    if (substitutePratoQuente) {
      drawLine(`Substituição: Prato Quente → ${ALMOCO_JANTAR.label.split('(')[0].trim()}`,
        `${guests} × ${fmtBRL2(ALMOCO_JANTAR.pricePerPerson)} por pessoa`,
        fmtBRL(ALMOCO_JANTAR.pricePerPerson * guests));
    }
    y += 2;

    /* Drinks */
    if ((selectedDrinks || []).length > 0) {
      drawSectionTitle('BEBIDAS');
      selectedDrinks.forEach((id) => {
        const item = drinkItems.find(d => d.id === id);
        if (!item) return;
        drawLine(item.label, `${guests} × ${fmtBRL(item.pricePerPerson)} por pessoa`, fmtBRL(item.pricePerPerson * guests));
      });
      y += 2;
    }

    /* Structure */
    drawSectionTitle('ESTRUTURA BUFFET (INCLUSA)');
    drawLine('Taças, pratos, talheres, rechauds, fogão, forno, gás',
      `${guests} × ${fmtBRL(STRUCTURE_FEE_PER_PERSON)} por pessoa`,
      fmtBRL(STRUCTURE_FEE_PER_PERSON * guests));
    y += 2;
  } else if (serviceType === 'delivery') {
    drawSectionTitle('ITENS DA ENCOMENDA');
    Object.entries(deliveryQuantities || {}).forEach(([id, qty]) => {
      if (qty <= 0) return;
      const item = deliveryItems.find(d => d.id === id);
      if (!item) return;
      drawLine(item.label, `${qty} ${item.unit} × ${fmtBRL(item.pricePerUnit)}`, fmtBRL(item.pricePerUnit * qty));
    });
  }

  /* ===== TOTAL BOX ===== */
  y = ensure(y, 32);
  y += 4;
  doc.setFillColor(...COLORS.black);
  doc.roundedRect(15, y, W - 30, 26, 2, 2, 'F');
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);
  doc.setTextColor(...COLORS.lightChamp);
  doc.text('VALOR TOTAL ESTIMADO', 22, y + 11);
  doc.setFont('times', 'bold');
  doc.setFontSize(22);
  doc.setTextColor(...COLORS.ivory);
  doc.text(fmtBRL(totalPrice), W - 22, y + 17, { align: 'right' });
  y += 34;

  /* ===== PAGE 2 — Inclusos + Credibilidade ===== */
  if (serviceType === 'presencial' && selectedPackage) {
    y = newPage();

    doc.setFont('times', 'bold');
    doc.setFontSize(18);
    doc.setTextColor(...COLORS.textDark);
    doc.text('O que está incluso no seu evento', 15, y);
    doc.setDrawColor(...COLORS.champagne);
    doc.setLineWidth(0.5);
    doc.line(15, y + 2, 50, y + 2);
    y += 8;
    doc.setFont('helvetica', 'italic');
    doc.setFontSize(10);
    doc.setTextColor(...COLORS.textMuted);
    doc.text('Tudo isso já está no valor — sem custos surpresa.', 15, y);
    y += 10;

    /* Two columns */
    const colWidth = (W - 36) / 2;
    const colY = y;

    // Team
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.setTextColor(...COLORS.bronze);
    doc.text('EQUIPE PROFISSIONAL', 15, y);
    y += 6;
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    (selectedPackage.staff || []).forEach((role) => {
      y = ensure(y, 6);
      doc.setTextColor(...COLORS.champagne);
      doc.text('•', 15, y);
      doc.setTextColor(...COLORS.textDark);
      doc.text(role, 19, y);
      y += 5.2;
    });

    let y2 = colY;
    const x2 = 15 + colWidth + 6;
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.setTextColor(...COLORS.bronze);
    doc.text('ESTRUTURA COMPLETA', x2, y2);
    y2 += 6;
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    structureItems.forEach((item) => {
      doc.setTextColor(...COLORS.champagne);
      doc.text('•', x2, y2);
      doc.setTextColor(...COLORS.textDark);
      doc.text(item, x2 + 4, y2);
      y2 += 5.2;
    });
    y = Math.max(y, y2) + 6;

    /* Partners */
    if ((selectedPartners || []).length > 0) {
      y = ensure(y, 20);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(9);
      doc.setTextColor(...COLORS.bronze);
      doc.text('PARCEIROS DE INTERESSE', 15, y);
      y += 6;
      const names = selectedPartners.map(id => partners.find(p => p.id === id)?.label).filter(Boolean);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(9);
      doc.setTextColor(...COLORS.textDark);
      const txt = doc.splitTextToSize(names.join('  •  '), W - 30);
      doc.text(txt, 15, y);
      y += txt.length * 5.2 + 4;
    }

    /* Credibility band */
    y = ensure(y, 50);
    y += 4;
    doc.setFillColor(...COLORS.softBg);
    doc.setDrawColor(...COLORS.champagne);
    doc.setLineWidth(0.3);
    doc.roundedRect(15, y, W - 30, 38, 2, 2, 'FD');

    doc.setFont('times', 'bold');
    doc.setFontSize(13);
    doc.setTextColor(...COLORS.bronze);
    doc.text('Por que escolher o Buffet MultiEventos', 22, y + 9);

    const credibility = [
      ['+30 anos', 'de experiência em eventos'],
      ['+500 eventos', 'realizados com excelência'],
      ['98%', 'de satisfação dos clientes'],
    ];
    const credColW = (W - 60) / 3;
    credibility.forEach(([big, small], i) => {
      const cx = 22 + i * credColW;
      doc.setFont('times', 'bold');
      doc.setFontSize(15);
      doc.setTextColor(...COLORS.bronze);
      doc.text(big, cx, y + 22);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8);
      doc.setTextColor(...COLORS.textMuted);
      doc.text(small, cx, y + 28);
    });
    y += 46;

    y = ensure(y, 22);
    doc.setFont('helvetica', 'italic');
    doc.setFontSize(10);
    doc.setTextColor(...COLORS.textMuted);
    const closing = doc.splitTextToSize(
      'Cada evento é único e merece atenção aos mínimos detalhes. Nossa equipe está pronta para transformar a sua celebração em uma experiência inesquecível — do primeiro contato à última taça brindada.',
      W - 30
    );
    doc.text(closing, 15, y);
    y += closing.length * 5 + 6;

    doc.setDrawColor(...COLORS.border);
    doc.setLineWidth(0.2);
    doc.line(15, y, W - 15, y);
    y += 5;
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.setTextColor(...COLORS.textMuted);
    doc.text('Este orçamento é uma estimativa baseada nos itens selecionados.', 15, y);
    doc.text('Valores finais podem variar conforme cardápio personalizado e disponibilidade da data.', 15, y + 4);
  } else {
    y = ensure(y, 20);
    doc.setDrawColor(...COLORS.border);
    doc.setLineWidth(0.2);
    doc.line(15, y, W - 15, y);
    y += 5;
    doc.setFont('helvetica', 'italic');
    doc.setFontSize(8);
    doc.setTextColor(...COLORS.textMuted);
    doc.text('Pedido sob encomenda — entrega e prazos a combinar via WhatsApp.', 15, y);
  }

  pageFooter();
  const safe = (leadName || 'cliente').replace(/\s+/g, '_').toLowerCase();
  doc.save(`orcamento_${safe}_${Date.now()}.pdf`);
};
